import {node_each} from 'lib/utilities';

export default function init_scroll_animations() {
    init_feather_parallax();
    init_parallax();
    init_mobile_parallax();
    init_sections();
}

function init_feather_parallax() {
    const images = document.querySelectorAll('.feather-icon-overlay .parallax-layer');

    node_each(images, image => {
        App.scrollAnimations.fromTo(image, {
            scale: 1.15,
            yPercent: 15 / 2,
            rotate: '-5deg'
        }, {
            scale: 1,
            yPercent: 0,
            rotate: '5deg',
            transformOrigin: 'center center'
        })
    })
}

function init_parallax() {
    const images = document.querySelectorAll('.full-size-background');

    node_each(images, (image, index) => {
        App.scrollAnimations.fromTo(image, {
            scale: 1.15,
            yPercent: 15 / 2
        }, {
            scale: 1,
            yPercent: 0,
            transformOrigin: 'center center',
            // Due to the power2 easing (and how it slows down toward the end), the first section doesn't show a
            // significant enough parallax/zoom animation because it is above the fold and therefore the scrollTrigger
            // range position is already part way through when the scroll is at zero.
            ease: index === 0 ? 'linear' : 'power2.out'
        })
    })
}

function init_mobile_parallax() {
    const images = document.querySelectorAll('.image-text-image .object-fit-fallback');

    node_each(images, image => {
        App.scrollAnimations.fromTo(image, {
            scale: 1.15,
            yPercent: 15 / 2
        }, {
            scale: 1,
            yPercent: 0,
            transformOrigin: 'center center',
            condition: App.breakpoints.callback('<', 'lg'),
            ease: 'power2.out'
        })
    })
}

function init_sections() {
    const sections = document.querySelectorAll('.animate-x');

    node_each(sections, (section, index) => {
        const x = index % 2 === 0 ? -40 : 40;

        App.scrollAnimations.fromTo(section, {
            x
        }, {
            x: -x,
            condition: App.breakpoints.callback('>=', 'lg')
        })
    })
}